import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { Button, CircularProgress, IconButton, Skeleton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { Input } from 'antd';
import CloseIcon from '@mui/icons-material/Close';


import { Rating } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TextArea from 'antd/es/input/TextArea';

export default function Categories({propsData,tab}) {
  let[otherCategories,handleOtherCategories]=useState([])
let [errorOthers,setErrorErrorOthers]=useState(false)
const location = useLocation()
const [routes,setRoutes]=useState(location.pathname.split("/"))


useEffect(()=>{
  setErrorErrorOthers(true)
  
  axios.get(`${process.env.REACT_APP_URL}/api/category/GetAllCategories_dukana`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    console.log(res.data);
    handleOtherCategories(res.data)
    setErrorErrorOthers(false)
  })
  .catch(error=>{
    console.log(error);
  })
},[propsData.equilizer,location])

let sampleErrorMaterial=[1,2,3,4,5]

  return (
    <div  className={`categoryListHome ${tab&&"categoryListHomeFull"}`}>    
    <Link to="/?tab=categories" style={{textDecoration:"none",color:"inherit"}}><h3 style={{textAlign:"center"}}>Categories</h3></Link>
    {!errorOthers?<div className='singleCategoryRightAll categoryListHomeAll'>
          {otherCategories?.map((e,index)=>{
                return <EachCategories item={e} key={index}/>
          })}
    </div>:
      <div className='singleCategoryRightAll'>
           {sampleErrorMaterial.map(e=>{
            return <Skeleton variant="rectangular" width={210} height={60} />

           })}
      </div>
    
    }

</div>
  )
}


const EachCategories=({item})=>{

  return(
   <Link to={`/categories/${item?._id}`} style={{color:"inherit",textDecoration:"none"}}>
      <div className='singleCategoryEach'>
        <div className='singleCategoryEachName'>{item?.name}</div>
        <div className='singleCategoryEachShop'>from {item?.shop?.shope_name}</div>
      </div>
   
   </Link>
  )
}

